import { AxiosError } from 'axios';

export const logApiError = (error: AxiosError, prefix = '[API Error]') => {
  const { config, response } = error;
  const method = config?.method?.toUpperCase() ?? 'UNKNOWN';
  const url = config?.url ?? 'UNKNOWN';
  const baseURL = config?.baseURL ?? '';
  const fullUrl = url.startsWith('http') ? url : `${baseURL}${url}`;
  const status = response?.status ?? 'NO_RESPONSE';
  const errorData = response?.data;

  console.error(
    `${prefix} ${method} ${fullUrl}\n` +
      `  Status: ${status}\n` +
      `  Response:`,
    errorData ?? error.message
  );
};
